import { useState, useEffect } from 'react';

export const useGodState = (): boolean => {
    // GodState must defaultly be true, because we want to
    // use it to judge if we want to show advertisements.
    // `false`: Will not show ads, show placeholders Instead
    // or collapse it.  `true`: Will show advertisements.
    const [state, setState] = useState<boolean>(true);

    const handleAdFetchError = () => {
        setState(false);
    };

    useEffect(() => {
        window.addEventListener('LOAD_GOD_AD_ASM_FAILED', handleAdFetchError);
        return () => {
            window.removeEventListener('LOAD_GOD_AD_ASM_FAILED', handleAdFetchError);
        };
    }, []);
    return state;
};



// WEBPACK FOOTER //
// ./src/hooks/useGodState.ts